export var breakpoints = {
  mobile: '320px',
  xs: '375px',
  sm: '576px',
  md: '768px',
  lg: '1280px',
  xl: '1440px'
};